import React from 'react';

const Separator = () => <div className="artp-ui-pagination-separator">...</div>;

export default Separator;
